import { ProfileInfo, DiveExperience, RentalInfo } from './user-forms'
import { FormattedMessage } from 'react-intl'
import './participant.scss'
import get from 'lodash/get'
import ParticipantSwitch from './ParticipantSwitch'

export default function ParticipantForm({
  field,
  activity,
  index,
  values,
  isCheckout,
  change,
}) {
  const participant = get(values, `${field}`)
  return (
    <div className='participant-container'>
      <div className='participant-header'>
        <div className='participant-title'>
          <FormattedMessage id='participant' defaultMessage='Participant' />
          &nbsp;
          {index + 1}
        </div>
        <ParticipantSwitch
          initValues={values}
          formId={field}
          selectedId={!index ? 0 : 'other_participant'}
          onOptionChange={change}
        />
      </div>
      <ProfileInfo field={field} isCheckout={isCheckout} isElearning={activity?.isElearning} />
      {!activity.isNonExperienced && (
        <DiveExperience
          field={field}
          values={participant}
          productType={values.productType}
        />
      )}
      {activity.hasRental && (
        <RentalInfo field={field} values={participant} change={change} />
      )}
    </div>
  )
}
